// src/algorithms/error-diffusion/index.ts
import type { DitherAlgorithm } from '../../core/types';
import { KERNELS } from './_kernels';

export const ERROR_DIFFUSION_ALGORITHMS: DitherAlgorithm[] = [
  ['none',                  'None'],
  ['floyd-steinberg',       'Floyd-Steinberg'],
  ['false-floyd-steinberg', 'False Floyd-Steinberg'],
  ['atkinson',              'Atkinson'],
  ['jarvis',                'Jarvis-Judice-Ninke'],
  ['stucki',                'Stucki'],
  ['burkes',                'Burkes'],
  ['sierra',                'Sierra'],
  ['sierra-two-row',        'Sierra Two-Row'],
  ['sierra-lite',           'Sierra Lite'],
  ['stevenson-arce',        'Stevenson-Arce'],
  ['riemersma',             'Riemersma (Hilbert)'],
].map(([id, label]) => ({
  id: id!, label: label!,
  kind: 'error-diffusion' as const,
  runner: 'cpu' as const,
  tileRange: null,
}));

// Sanity check at import time
for (const a of ERROR_DIFFUSION_ALGORITHMS) {
  if (a.id !== 'none' && a.id !== 'riemersma' && !KERNELS[a.id]) {
    throw new Error(`error-diffusion: missing kernel for ${a.id}`);
  }
}
